import axios from "axios";
import { BASE_URL } from "../_constants/urlConstants";
import { LABORCREW } from "../_constants/actionConstants";
import raiseWarning from "./raiseWarning";
import raiseError from "./raiseError";

const deleteCrew = (laborCrewId, projectId) => async (dispatch) => {
  dispatch({ type: LABORCREW.DELETE });
  const apiEndpoint = `${BASE_URL}/api/LaborCrews/${laborCrewId}/InProject/${projectId}`;
  try {
    const res = await axios.delete(apiEndpoint);
    if (res.data.message) {
      dispatch({ type: LABORCREW.DELETE_REJECTED });
      raiseWarning(LABORCREW.DELETE_REJECTED, res.data.message);
    }
    dispatch({ type: LABORCREW.DELETE_FULFILLED });
  } catch (err) {
    raiseError(LABORCREW.DELETE_REJECTED, err.response.data);
  }
};

const add = (newLaborCrewData) => async (dispatch) => {
  dispatch({ type: LABORCREW.ADD });
  const apiEndpoint = `${BASE_URL}/api/LaborCrews`;
  try {
    const res = await axios.post(apiEndpoint, newLaborCrewData);
    if (res.data.message) {
      dispatch({ type: LABORCREW.ADD_REJECTED });
      raiseWarning(LABORCREW.ADD_REJECTED, res.data.message);
    }
    dispatch({ type: LABORCREW.ADD_FULFILLED });
  } catch (err) {
    raiseError(LABORCREW.ADD_REJECTED, err.response.data);
  }
};

const update = (laborCrewData) => async (dispatch) => {
  dispatch({ type: LABORCREW.EDIT });
  const apiEndpoint = `${BASE_URL}/api/LaborCrews`;
  try {
    const res = await axios.put(apiEndpoint, laborCrewData);
    if (res.data.message) {
      raiseWarning(LABORCREW.EDIT_REJECTED, res.data.message);
      dispatch({ type: LABORCREW.EDIT_REJECTED });
    }
    dispatch({ type: LABORCREW.EDIT_FULFILLED });
  } catch (err) {
    raiseError(LABORCREW.EDIT_REJECTED, err.response.data);
  }
};

const getAll = (projectId) => async (dispatch) => {
  dispatch({ type: LABORCREW.FETCH_ALL });
  const apiEndpoint = `${BASE_URL}/api/LaborCrews/List/${projectId}`;
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({
      type: LABORCREW.FETCH_ALL_FULFILLED,
      projLaborCrewList: res.data,
      projectId,
    });
  } catch (err) {
    raiseError(LABORCREW.FETCH_ALL_REJECTED, err.response.data);
  }
};

const nameExists = (projId, lcName) => async (dispatch) => {
  dispatch({ type: LABORCREW.GENERIC_REQUEST });
  const apiEndpoint = `${BASE_URL}/api/LaborCrews/Name/${lcName}/ExistsInProject/${projId}`;
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({ type: LABORCREW.GENERIC_REQUEST_FULFILLED });
    return res.data;
  } catch (err) {
    raiseError(LABORCREW.GENERIC_REQUEST_REJECTED, err.response.data);
  }
};

// Keep this interface alphabetical
const laborCrewActions = {
  add,
  getAll,
  deleteCrew,
  nameExists,
  update,
};

export default laborCrewActions;
